module.exports = __webpack_public_path__ + "static/img/法制教育展厅.4eb4ab22.png";